export default __webpack_public_path__ + "static/media/popout.e1f2960e.svg";